import SectionHeader from "@/components/base/SectionHeader";
import { primaryNaics, additionalNaics } from "@/mocks/naics";

interface NAICSCodesSectionProps {
  title?: string;
  subtitle?: string;
  description?: string;
}

export default function NAICSCodesSection({
  title = "NAICS Codes",
  subtitle = "Procurement Classification",
  description =
    "North American Industry Classification System (NAICS) codes registered for Mitaja Corporation.",
}: NAICSCodesSectionProps) {
  return (
    <div>
      <SectionHeader title={title} subtitle={subtitle} description={description} />

      {/* Primary NAICS */}
      <div className="card-base p-6 md:p-7 mb-6 border-l-4 border-l-primary-500">
        <span className="inline-flex items-center px-2.5 py-1 rounded-md bg-primary-100 text-primary-700 text-xs font-bold uppercase tracking-wider mb-3">
          Primary NAICS
        </span>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
          <p className="text-2xl md:text-3xl font-bold text-foreground-900 tracking-tight">
            {primaryNaics.code}
          </p>
          <p className="text-base font-semibold text-foreground-700">
            {primaryNaics.description}
          </p>
        </div>
      </div>

      {/* Additional NAICS */}
      <p className="text-xs font-semibold uppercase tracking-wider text-secondary-700 mb-3">
        Additional NAICS Codes
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {additionalNaics.map((naics) => (
          <div
            key={naics.code}
            className="card-base p-5 flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-3"
          >
            <span className="text-sm font-bold text-primary-700 whitespace-nowrap">
              {naics.code}
            </span>
            <span className="text-sm font-medium text-foreground-700 leading-snug">
              {naics.description}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}